import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24InviteG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 1.5H4a.5.5 0 0 0-.492.41L3.5 6v12a.5.5 0 0 0 .41.492L4 18.5h16a.5.5 0 0 0 .492-.41L20.5 18V6a.5.5 0 0 0-.41-.492z"
      }), /*#__PURE__*/jsx("path", {
        d: "M4.568 7.183a.75.75 0 0 1 .955-.22l.094.059 6.376 4.672 6.293-4.67a.75.75 0 0 1 .977.072l.072.084a.75.75 0 0 1-.071.976l-.084.073-6.737 5a.75.75 0 0 1-.799.06l-.091-.057-6.823-5a.75.75 0 0 1-.162-1.049"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24InviteG$1 = Svg24InviteG;

export { Svg24InviteG$1 as default };
